// @flow

import * as React from 'react';

import { Info } from 'lucide-react';

import {
  selectCartUUID,
  selectCartIsActive,
  type DecoratedProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Badge, Base, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

type Props = {
  productId: DecoratedProduct['id'],
  productClaims?: number,
};

export default function ClaimsRow({
  productId,
  productClaims,
}: Props): React.MixedElement {
  const active = useAppSelector(selectCartIsActive);
  const cartId = useAppSelector(selectCartUUID);
  const { __ } = useTranslator();

  const listRowProps = {
    icon: !productClaims && <Info size={20} />,
    cta: active && (
      <Button
        kind="link"
        type="button"
        to={`/cart/${cartId}/configure/${productId}/claims`}
      >
        {__('Read')}
      </Button>
    ),
    intent: productClaims ? 'muted' : 'warning',
  };
  return (
    <ListRow {...listRowProps}>
      <Base flex gap="spacing-2x" flexAlignItemsCenter>
        {__('Trademark notice')}
        {productClaims ? (
          <Badge intent="success">{__('Acknowledged')}</Badge>
        ) : (
          <Badge intent="warning">{__('Pending')}</Badge>
        )}
      </Base>
    </ListRow>
  );
}
